// extracted by mini-css-extract-plugin
export default {"title":"SecondForm_title__pIfpL","footer":"SecondForm_footer__YjGXg","recorType":"SecondForm_recorType__W6y67","recordTypeTitle":"SecondForm_recordTypeTitle__1pzNc"};